"use client";

// Ported from the private `packages/sdk/react/src/tools/tool-view.tsx`
// (plan 030). The provider half of that file lives in
// `./tool-view-provider.tsx` (added in the plan-024b parity pass — JSX
// can't live in this `.ts` module); the block mounts it around the
// transcript so expandable tool rows respond to clicks again (the
// frozen-expandable gap recorded in plans/030a-tool-view-strategy.md §5).

import { createContext } from "react";

export type ToolViewContextType = {
  state: {
    /** Id of the tool currently auto-opened (most recent active tool). */
    autoOpenId: string | null;
    /** Tools the user has manually toggled (they own their state after that). */
    manuallyOpened: Set<string>;
  };
  actions: {
    setAutoOpen: (id: string) => void;
    registerManualOpen: (id: string) => void;
  };
  meta: {
    autoOpenEnabled: boolean;
  };
};

export const ToolViewContext = createContext<ToolViewContextType | null>(null);
